import type { GenericReview } from "../types";

/**
 * Sort function for Reviews by number of upvotes
 */
function sortReviewsByUpvotes(a: GenericReview, b: GenericReview) {
  if (a.counterUpvote > b.counterUpvote) return -1;
  if (a.counterUpvote < b.counterUpvote) return 1;
  return 0;
}

/**
 * Sort function for Reviews by created date
 */
function sortReviewsByCreated(a: GenericReview, b: GenericReview) {
  const dateA = new Date(a.createdAt);
  const dateB = new Date(b.createdAt);

  if (dateA < dateB) return -1;
  if (dateA > dateB) return 1;
  return 0;
}

export { sortReviewsByUpvotes, sortReviewsByCreated };
